const SelectItems = (props) => {
  const {items, selectedOption, setOption, disabledItems=[]} = props;
  return (
    <div className="flex gap-3 lg:gap-4 lg:justify-center lg:w-full">
      {items.map((item, index) => {
        return (
          <button 
            onClick={()=>{setOption(item)}}
            disabled={disabledItems.includes(item)}
          key={`item-${item}-${index}`} className={`grow text-sm lg:text-base whitespace-nowrap rounded-small px-4 lg:px-5 py-2 transition border border-purple-100 ${item === selectedOption ? `bg-purple-100 hover:bg-purple-hover text-white` : 'text-purple-100 hover:bg-gray-300/30 disabled:hover:bg-dark-gray disabled:hover:text-blue-dark'}`}>{item}</button>
        )
      })}
    </div>
  )
}

export default SelectItems;